const localizations = {
  translate: {
    es: "Traducir",
    zh: "翻译",
    ru: "Перевести",
    default: "Translate",
  },
  see_translation: {
    es: "Ver traducción",
    zh: "查看翻译",
    ru: "Посмотреть перевод",
    default: "See translation",
  },
  show_original: {
    es: "Ver idioma original",
    zh: "显示原文语言",
    ru: "Показать оригинал",
    default: "Show original",
  },
  english: {
    es: "Inglés",
    zh: "英语",
    ru: "Английский",
    default: "English",
  },
  spanish: {
    es: "Español",
    zh: "西班牙语",
    ru: "Испанский",
    default: "Spanish",
  },
  chinese: {
    zh: "中文",
    ru: "Китайский",
    default: "Chinese",
  },
  russian: {
    ru: "Русский",
    es: "Ruso",
    zh: "俄语",
    default: "Russian",
  },
};

export const _t = (key) => {
  const browserLanguages = navigator.languages || [navigator.language];
  const primaryLanguage = browserLanguages[0];
  const baseLanguage = primaryLanguage.split("-")[0];
  const mapping = localizations[key];
  return mapping[baseLanguage] || mapping.default;
};

export const languageOptions = [
  { key: 2, text: _t("spanish"), value: "es-US" },
  { key: 3, text: _t("english"), value: "en-US" },
  { key: 4, text: _t("chinese"), value: "zh-CN" },
  { key: 5, text: _t("russian"), value: "ru-RU" },];
